import React from 'react';
import { motion } from 'framer-motion';
import Home from './pages/Home';
import PanoGenerator from './pages/PanoGenerator';

function App() {
  const Page = process.env.REACT_APP_SITE_MODE === 'pano' ? PanoGenerator : Home;

  return (
    <div className="min-h-screen bg-dark text-white">
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Page />
      </motion.main>
    </div>
  );
}

export default App;
